var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExternalLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.80362 7.13806L9.99888 2.9428V5.33332H11.3322V0.666656H6.66555V1.99999H9.05607L4.86081 6.19525L5.80362 7.13806Z",
  fill: "#636766"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.6675 9.99999V7.33332H9.33415V9.99999H2.00081V2.66666H4.66748V1.33332H2.00081C1.26443 1.33332 0.66748 1.93028 0.66748 2.66666V9.99999C0.66748 10.7364 1.26443 11.3333 2.00081 11.3333H9.33415C10.0705 11.3333 10.6675 10.7364 10.6675 9.99999Z",
  fill: "#636766"
})));
export { SvgExternalLink as ReactComponent };
export default __webpack_public_path__ + "2338a5d5d3d398e1a97132802f49ca68.svg";